// Pure label helpers for link artifacts (asset_type EXTERNAL_URL). Kept free of
// icon/$icon deps so the widely-imported useAssetInfo can pull the label logic
// without dragging the domain-icon table (see externalUrlIcon.ts) into early
// chunks like the SPA route-metadata bundle.
/**
 * Parse a URL defensively, rejecting non-http(s) protocols; the value
 * originates from a model and is untrusted. Stricter than the general-purpose
 * `parseUrl` in `#pplx/frontend/common/files/urls.js`.
 */
export function parseHttpUrl(rawUrl) {
    if (!rawUrl)
        return null;
    try {
        const parsed = new URL(rawUrl);
        if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:')
            return null;
        return parsed;
    }
    catch {
        return null;
    }
}
/** Match the catalog's PR normalization without hiding deeper GitHub links. */
export function isGitHubPullRequestUrl(rawUrl) {
    const parts = rawUrl?.trim().match(/^([^:]+):\/\/([^/]+)(\/[^?#]*)$/);
    return Boolean(parts &&
        parts[1]?.toLowerCase() === 'https' &&
        parts[2]?.toLowerCase() === 'github.com' &&
        /^\/[^/]+\/[^/]+\/pull\/[1-9][0-9]*\/?$/.test(parts[3] ?? ''));
}
/** The domain label shown to users: the host without a leading `www.`. */
function stripWww(hostname) {
    return hostname.replace(/^www\./, '');
}
/** The host of a valid URL (www. stripped), or '' for a malformed URL. */
export function getExternalUrlDomain(url) {
    const parsed = parseHttpUrl(url);
    return parsed ? stripWww(parsed.hostname) : '';
}
/** Display label: the explicit title when present, else a domain-derived label. */
export function getExternalUrlLabel(url, title) {
    const trimmedTitle = title?.trim();
    if (trimmedTitle)
        return trimmedTitle;
    const parsed = parseHttpUrl(url);
    if (parsed)
        return stripWww(parsed.hostname);
    return url ?? '';
}
//# sourceMappingURL=externalUrl.js.map